import React, { useState } from 'react';
import {
  Box,
  Container,
  Stack,
  Paper,
  TextField,
  useTheme,
} from '@mui/material';
import { CorrectAnswer } from '../room/game/CorrectAnswer';
import { StagedGameHeader } from './StagedGameHeader';
import { ScoreBar } from '../room/game/score-bar';
import { Player } from '../room/types';
import { StagedQuestionAnswer } from './staged-question-answer/QuestionAnswer';
import { StagedPlayerInput } from './staged-player-input/StagedPlayerInput';

const initPlayerSelf: Player = {
  avatarPublicId: '',
  avatarUrl:
    'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1672787530/par-twitter-400_tzyqtc.png',
  confirmedReady: false,
  correctAnswer: false,
  currentScore: 0,
  incorrectAnswer: false,
  fuzzyScore: null,
  isPromptAnswer: false,
  location: '',
  parScore: 0,
  profileId: 'a',
  timerLimitReached: false,
  totalPenalty: 0,
  username: 'Player 1',
};

const initPlayerThem: Player = {
  avatarPublicId: '',
  avatarUrl:
    'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1672787525/PAR_Bricks_veacrr.png',
  confirmedReady: false,
  correctAnswer: false,
  currentScore: 0,
  incorrectAnswer: false,
  fuzzyScore: null,
  isPromptAnswer: false,
  location: '',
  parScore: 0,
  profileId: 'b',
  timerLimitReached: false,
  totalPenalty: 0,
  username: 'Player 2',
};

export const Stager = () => {
  const [playerSelf, setPlayerSelf] = useState(initPlayerSelf);
  const [playerThem, setPlayerThem] = useState(initPlayerThem);
  const [stageSettings, setStageSettings] = useState<any>();

  const theme = useTheme();

  const scoreBars = (
    <>
      <ScoreBar
        avatar={playerSelf.avatarUrl}
        mode={'match'}
        score={playerSelf.parScore || 0}
        username={playerSelf.username || 'Player 1'}
        usernameLocation={'left'}
      ></ScoreBar>
      <ScoreBar
        avatar={playerThem.avatarUrl}
        mode={'match'}
        score={playerThem.parScore}
        username={playerThem.username || 'Player 2'}
        usernameLocation={'right'}
      ></ScoreBar>
    </>
  );

  const handleGameClock = (value: string) =>
    setStageSettings((prev: any) => ({ ...prev, gameClock: value }));
  const handleCategory = (value: string) =>
    setStageSettings((prev: any) => ({ ...prev, category: value }));
  const handlePar = (value: string) =>
    setStageSettings((prev: any) => ({ ...prev, par: value }));
  const handleQuestion = (value: string) =>
    setStageSettings((prev: any) => ({ ...prev, question: value }));
  const handleAnswer = (value: string) => {
    const answer: string[][] = [];
    const splitWord = value.split(' ');
    splitWord.forEach((w) => {
      answer.push(w.split(''));
    });
    answer.forEach((w, i) => {
      w.forEach((l, j) => {
        if (l === '~') {
          console.log('l', l);
          answer[i][j] = '';
        }
      });
    });
    setStageSettings((prev: any) => ({ ...prev, answer: answer }));
  };
  const handlePlayerOneUsername = (value: string) =>
    setPlayerSelf((prev: any) => ({ ...prev, username: value }));
  const handlePlayerOneTotalScore = (value: string) =>
    setPlayerSelf((prev: any) => ({ ...prev, parScore: value }));
  const handlePlayerTwoUsername = (value: string) =>
    setPlayerThem((prev: any) => ({ ...prev, username: value }));
  const handlePlayerTwoTotalScore = (value: string) =>
    setPlayerThem((prev: any) => ({ ...prev, parScore: value }));
  const handlePlayerInput = (value: string) =>
    setStageSettings((prev: any) => ({ ...prev, playerInput: value }));

  return (
    <Box sx={{ paddingBottom: '100px' }}>
      <Container sx={{ marginBottom: 5 }}>
        <Stack direction={'row'} spacing={2}>
          <TextField
            id="playerOneUsername"
            label="P1 Username"
            variant="standard"
            onChange={(e) => handlePlayerOneUsername(e.target.value)}
          />
          <TextField
            id="playerOneTotalScore"
            label="P1 Total Score"
            variant="standard"
            onChange={(e) => handlePlayerOneTotalScore(e.target.value)}
          />
          <TextField
            id="playerTwoUsername"
            label="P2 Username"
            variant="standard"
            onChange={(e) => handlePlayerTwoUsername(e.target.value)}
          />
          <TextField
            id="playerTwoTotalScore"
            label="P2 Total Score"
            variant="standard"
            onChange={(e) => handlePlayerTwoTotalScore(e.target.value)}
          />
        </Stack>
        <Stack direction={'row'} spacing={2} mt={2}>
          <TextField
            id="gameClock"
            label="Game Clock"
            variant="standard"
            onChange={(e) => handleGameClock(e.target.value)}
          />
          <TextField
            id="category"
            label="Category"
            variant="standard"
            onChange={(e) => handleCategory(e.target.value)}
          />
          <TextField
            id="par"
            label="Par"
            variant="standard"
            onChange={(e) => handlePar(e.target.value)}
          />
          <TextField
            id="question"
            label="Question"
            variant="standard"
            onChange={(e) => handleQuestion(e.target.value)}
          />
          <TextField
            id="answer"
            label="Answer (~ for blanks)"
            variant="standard"
            onChange={(e) => handleAnswer(e.target.value)}
          />
        </Stack>
        <Stack direction={'row'} spacing={2} mt={2}>
          <TextField
            id="playerInput"
            label="Player Input"
            variant="standard"
            onChange={(e) => handlePlayerInput(e.target.value)}
          />
        </Stack>
      </Container>
      <Container
        sx={{
          position: 'sticky',
          top: 0,
          backgroundColor: theme.palette.background.default + 'e6',
        }}
      >
        {scoreBars}
        <Stack spacing={1} marginTop={1}>
          <StagedGameHeader
            category={stageSettings?.category || 'all'}
            gameClock={stageSettings?.gameClock || 0}
            mode={'match'}
            par={stageSettings?.par || 1}
            playerSelf={playerSelf}
            playerThem={playerThem}
            questionIndex={2}
            totalNumQuestions={10}
          ></StagedGameHeader>
          <div style={{ height: '24px' }}></div>
        </Stack>
      </Container>
      <Box sx={{ height: '300px' }}>
        <StagedQuestionAnswer
          answer={
            stageSettings?.answer || [
              ['a', 'n', 's'],
              ['w', 'e', 'r'],
            ]
          }
          question={stageSettings?.question || 'question here'}
          timerLimitReached={false}
          unrevealedIndex={[1]}
          correctAnswer={playerSelf.correctAnswer}
          properNameShortAnswer={undefined}
        ></StagedQuestionAnswer>
      </Box>
      <Paper
        elevation={6}
        sx={{
          height: { xs: 300, sm: '7rem' },
          width: '100%',
          position: 'sticky',
          bottom: 0,
        }}
      >
        <Stack
          spacing={0}
          alignItems="center"
          justifyContent="center"
          height={'100%'}
        >
          <StagedPlayerInput
            playerInput={stageSettings?.playerInput || 'input'}
          ></StagedPlayerInput>
          <CorrectAnswer player={playerSelf}></CorrectAnswer>
        </Stack>
      </Paper>
    </Box>
  );
};
